/* eslint-disable max-len */
/* eslint-disable no-case-declarations */
import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { classNameTriskeleParser } from '../../utilities/customStyles';

import DynamicDialog from './components/DynamicDialog';
import DailyRecommendationSkeleton from './components/skeleton/DailyRecommendationSkeleton';
import AddConfirmationDialog from './components/AddConfirmationDialog';
import { CONTAINED_BUTTON, OUTLINED_BUTTON, SEARCH_ICON } from '../../utilities/generatedClasses';
import RecommendationsList from './components/RecommendationsList';
import MeasuresList from '../../components/MeasuresList';
import RecommendationAccess from '../../dataAccess/RecommendationAccess';
import MasterAccess from '../../dataAccess/MasterAccess';
import { setUserProfile } from '../../redux/actions/userProfileAction';
import { cleanAndUpdateUnitArrayData, overlayTopSide, unOverlayTopSide } from '../../utilities/utils';
import Icon from '../../components/Icon';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
const AddRecommendation = () => {
  const [measures, setMeasures] = useState(null);
  const [RecommendationList, setRecommendations] = useState([]);
  const [modifiedRecommendations, setModifiedRecommendations] = useState([]);
  const [filteredMeasures, setFilteredMeasures] = useState(null);
  const [skeleton, setSkeleton] = useState(false);
  const [isDynamicDialogOpen, setDynamicDialogOpen] = React.useState(false);
  const [isAddConfirmationDialogOpen, setAddConfirmationOpen] = React.useState(false);
  const [otherData, setOtherData] = React.useState(null);

  const topFilterData = useSelector(state => state.widgetFiltes);
  const contextcache = useSelector(state => state.context);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const convertRecommendationHoursMinutes = (recommendations) => {
        recommendations.forEach(element => {
            if(element && element.QtyDescrptr_Qty_UnitIdArray && element.QtyDescrptr_Qty_UnitIdArray[0] 
              && element.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr === 'HourMinuteQty'){
                let hoursMinutes = element.QtyDescrptr_Qty_UnitIdArray[0].Qty.split(":");
                element.QtyDescrptr_Qty_UnitIdArray = [
                  { QtyDescrptr: "Hours", Qty: hoursMinutes[0], UnitId: "949"},
                  { QtyDescrptr: "Minutes", Qty: hoursMinutes[1], UnitId: "949"}
                ]
            }
          });
        recommendations.forEach(element => {
            if (
              element &&
              element.QtyDescrptr_Qty_UnitIdArray &&
              element.QtyDescrptr_Qty_UnitIdArray[0]
            ) {
              const firstItem = element.QtyDescrptr_Qty_UnitIdArray[0];

              // Existing HourMinuteQty logic
              if (firstItem.QtyDescrptr === "HourMinuteQty") {
                let hoursMinutes = firstItem.Qty.split(":");

                element.QtyDescrptr_Qty_UnitIdArray = [
                  { QtyDescrptr: "Hours", Qty: hoursMinutes[0], UnitId: "949" },
                  { QtyDescrptr: "Minutes", Qty: hoursMinutes[1], UnitId: "949" }
                ];
              }

              else if (firstItem.QtyDescrptr === "MinutesQty") {
                const totalMinutes = Number(firstItem.Qty || 0);

                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const newArray = [];

                if (hours > 0) {
                  newArray.push({
                    QtyDescrptr: "Hours",
                    Qty: hours.toString(),
                    UnitId: "949"
                  });
                }

                if (minutes > 0) {
                  newArray.push({
                    QtyDescrptr: "Minutes",
                    Qty: minutes.toString(),
                    UnitId: "949"
                  });
                }

                // If totalMinutes was 0
                if (newArray.length === 0) {
                  newArray.push({
                    QtyDescrptr: "Minutes",
                    Qty: "0",
                    UnitId: "949"
                  });
                }

                element.QtyDescrptr_Qty_UnitIdArray = newArray;
              }
            }
          });

          return recommendations;
  }
  // Get List Of Recommendations
  const getRecommendations = () => {
    const { clientId } = window;

    RecommendationAccess.getListOfRecommendations(clientId)
      .then((response) => {
        if (response && response.data.length > 0) {
          for (let i = 0; i < response.data.length; i += 1) {
            const measure = contextcache.measurements.find(x => x.MeasureId === response.data[i].MeasureId);

            if (measure) {
              let qtyArrayUnitDesc = response.data[i].QtyDescrptr_Qty_UnitIdArray;
              if (!Array.isArray(qtyArrayUnitDesc)) {
                try {
                  qtyArrayUnitDesc = qtyArrayUnitDesc.replaceAll("'", '"');
                  qtyArrayUnitDesc = JSON.parse(qtyArrayUnitDesc);

                  for (let j = 0; j < qtyArrayUnitDesc.length; j += 1) {
                    const unit = contextcache.units.find(x => x.UnitID === qtyArrayUnitDesc[j].UnitId);
                    if (unit) {
                      qtyArrayUnitDesc[j].Unit = unit.UnitAbrvName;
                    }
                  }
                  response.data[i].QtyDescrptr_Qty_UnitIdArray = qtyArrayUnitDesc;
                } catch (ex) {
                  response.data[i].QtyDescrptr_Qty_UnitIdArray = [
                    { QtyDescrptr: 'Qty', Qty: 0, UnitId: '0' }
                  ];
                }
              } else {
                response.data[i].QtyDescrptr_Qty_UnitIdArray = [];
              }
              const startDateStr = response.data[i].StartDate;
              const [yearS, monthS, dayS] = startDateStr.split("-");
              const startDateFormatted = `${monthS}/${dayS}/${yearS}`;

              const endDateStr = response.data[i].EndDate;
              const [yearE, monthE, dayE] = endDateStr.split("-");
              const endDateFormatted = `${monthE}/${dayE}/${yearE}`;
              response.data[i].StartDateFormatted =  startDateFormatted;
              response.data[i].EndDateFormatted = endDateFormatted;
              response.data[i].RcmndtnType = measure.RcmndtnType;
              response.data[i].DayOfWeekFreqcy = response.data[i].DayofWeekFreqcy;
              response.data[i].MeasureCmpntCount = measure.MeasureCmpntCount;
              response.data[i].MeasureCmpntArray = measure.MeasureCmpntArray;
              response.data[i].MeasureName = measure.MeasureName;
              response.data[i].Category = measure.VisualTypeOne;
              response.data[i].icon = measure.MeasureIcon;
              response.data[i].iconClassName = classNameTriskeleParser(measure.VisualNameOne, measure.VisualTypeOne, 'Icon');
            }
          }


          let recommendations = response.data.filter(x => x.Category !== undefined);
          
          recommendations = convertRecommendationHoursMinutes(recommendations);
          const sortedMeasurements = [...contextcache.measurements].sort(
            (a, b) => Number(a.MeasureCtgySortOrdr) - Number(b.MeasureCtgySortOrdr)
          );

          const measureCtgyLookup = new Map(
            sortedMeasurements.map(m => [String(m.MeasureId), m.MeasureCtgyId])
          );

          const measureCtgyLookupObj = Object.fromEntries(measureCtgyLookup);
          const ctgyOrder = new Map();
          sortedMeasurements.forEach((m, idx) => {
            if (!ctgyOrder.has(m.MeasureCtgyId)) ctgyOrder.set(m.MeasureCtgyId, idx);
          });

          recommendations.sort((x, y) => {
            const aCtgy = measureCtgyLookup.get(String(x.MeasureId)) ?? measureCtgyLookupObj[x.MeasureId];
            const bCtgy = measureCtgyLookup.get(String(y.MeasureId)) ?? measureCtgyLookupObj[y.MeasureId];

            const aOrder = ctgyOrder.has(aCtgy) ? ctgyOrder.get(aCtgy) : Number.POSITIVE_INFINITY;
            const bOrder = ctgyOrder.has(bCtgy) ? ctgyOrder.get(bCtgy) : Number.POSITIVE_INFINITY;

            // tie-breaker: keep stable by using MeasureId if same category
            if (aOrder === bOrder) return String(x.MeasureId).localeCompare(String(y.MeasureId), undefined, {numeric: true});
            return aOrder - bOrder;
          });

          setRecommendations(recommendations);
        }
      })
      .catch(() => {
        navigate('/maintenance');
      });
  };

  // Get List Of Measures
  const getMeasures = () => {
    MasterAccess.getAllMeasuresCategory()
      .then((response) => {
        if (response && response.data) {
          const result = [];
          for (let i = 0; i < response.data.length; i += 1) {
            const header = response.data[i].MeasureCtgyName;
            if (topFilterData.widgetFiltes.includes(header)) {
              const selectedMeasures = contextcache.measurements.filter(x => x.MeasureCtgyId === response.data[i].MeasureCtgyId);
              result.push({
                name: header,
                values: selectedMeasures
              });
            }
          }
          setSkeleton(true);
          setMeasures(result);
          setFilteredMeasures(result);
        }
      })
      .catch((err) => {
        console.error(err);
        navigate('/maintenance');
      });
  };

  useEffect(() => {
    getMeasures();
    getRecommendations();
  }, [topFilterData]);


  const goBack = () => {
    navigate(-1)
  };

  const openDynamicDialog = (value, updatedData) => {
    overlayTopSide();
    setDynamicDialogOpen(true);
    const measureId = updatedData ? updatedData.MeasureId : value.MeasureId;
    const selectedMeasure = contextcache.measurements.find(x => x.MeasureId === measureId);
    const unitsArray = cleanAndUpdateUnitArrayData(selectedMeasure.UnitArray, contextcache.units);

    let dayofWeekFreqcys = updatedData ? updatedData.DayOfWeekFreqcy : [];
    // if (dayofWeekFreqcys.length > 0) {
    //   dayofWeekFreqcys = dayofWeekFreqcys.map(x => x.trim());
    // }

    const clonedQtyDesciptrValue = [];
    if (updatedData && updatedData.QtyDescrptr_Qty_UnitIdArray && updatedData.QtyDescrptr_Qty_UnitIdArray.length > 0) {
      updatedData.QtyDescrptr_Qty_UnitIdArray.forEach(val => clonedQtyDesciptrValue.push(Object.assign({}, val)));
    }
    setOtherData({
      type: updatedData ? 'EditSeries' : 'AddSeries',
      measure: selectedMeasure,
      recommendation: {
        RcmndtnSeriesId: updatedData ? updatedData.RcmndtnSeriesId : null,
        category: updatedData ? updatedData.category : value.VisualTypeOne,
        DayOfWeekFreqcy: dayofWeekFreqcys,
        EndDate: updatedData ? updatedData.EndDate : '',
        StartDate: updatedData ? updatedData.StartDate : '',
        QtyDescrptr_Qty_UnitIdArray: updatedData ? updatedData.QtyDescrptr_Qty_UnitIdArray : setQtyDescrptrData(value, unitsArray[0])
      },
      selectedRecommendation: {
        RcmndtnSeriesId:updatedData ? updatedData.RcmndtnSeriesId : null
      },
      unitArrays: unitsArray,
      QtyDescrptr_Qty_UnitIdArray_OldValue: clonedQtyDesciptrValue
     })

  };

  const openConfirmationDialog = () => {
    overlayTopSide();
    if (modifiedRecommendations.length) {
      setAddConfirmationOpen(true);
      setOtherData({
        selectedItems: modifiedRecommendations,
      });
    } else {
        toast.error(`No Recommendations Added!`, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
      });
    }
  };



  const createModel = (selectedItem, type) => {
    const baseModel = {
        Row: 0,
        MeasureId: selectedItem.MeasureId,
        DayOfWeekFreqcy: selectedItem.DayOfWeekFreqcy,
        StartDate: selectedItem.StartDate,
        EndDate: selectedItem.EndDate,
    };

    const qtyArray = selectedItem.QtyDescrptr_Qty_UnitIdArray;
    if(type === "HoursMinutes"){
      let QtyDescrptr_Qty_UnitIdArray = selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 2?selectedItem.QtyDescrptr_Qty_UnitIdArray: selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin
      return {
        ...baseModel,
        UnitId: "949",
        Unit1: "Hours",
        Unit2: "Minutes",
        Quantity1: QtyDescrptr_Qty_UnitIdArray[0].Qty ,
        Quantity2: QtyDescrptr_Qty_UnitIdArray[1].Qty ,
    };
    }
    else if (type === "single") {
        return {
            ...baseModel,
            UnitId: qtyArray[0].UnitId,
            Quantity: qtyArray[0].Qty,
        };
    } else if (type === "low-high") {
        return {
            ...baseModel,
            UnitId1: qtyArray[0].UnitId,
            UnitId2: qtyArray[1].UnitId,
            Quantity1: qtyArray[0].Qty,
            Quantity2: qtyArray[1].Qty,
        };
    } else if (type === "low-high-double") {
        return {
            ...baseModel,
            UnitId1: qtyArray[0].UnitId,
            UnitId2: qtyArray[1].UnitId,
            UnitId3: qtyArray[2].UnitId,
            UnitId4: qtyArray[3].UnitId,
            Quantity1: qtyArray[0].Qty,
            Quantity2: qtyArray[1].Qty,
            Quantity3: qtyArray[2].Qty,
            Quantity4: qtyArray[3].Qty,
        };
    }
    return baseModel;
}

  const parseRecommendationData = (model, type, action, recommendationSeriesId = null) => {
      const data = [];
      if(action === "Deleted"){
        data.push(
          `{'Row': '${model.Row}', 'RcmndtnSeriesId': '${recommendationSeriesId}' }`,
        );
        return data;
      } else {
          if(type === "HoursMinutes"){
            data.push(
                `{'Row': '${model.Row}','MeasureId': '${model.MeasureId}','UnitId': '${model.UnitId}', 'Qty': [{ 'QtyDescrptr': 'Hours', 'Qty': ${model.Quantity1} }, { 'QtyDescrptr': 'Minutes', 'Qty': ${model.Quantity2} }],'DayOfWeekFreqcy': '${model.DayOfWeekFreqcy}','StartDate': '${model.StartDate}','EndDate': '${model.EndDate}'${recommendationSeriesId ? `, 'RcmndtnSeriesId': '${recommendationSeriesId}'` : ''}}`,
            );
          } else if (type === "single") {
            data.push(
                `{'Row': '${model.Row}','MeasureId': '${model.MeasureId}','UnitId': '${model.UnitId}', 'Qty': [{ 'QtyDescrptr': 'Qty', 'Qty': ${model.Quantity} }],'DayOfWeekFreqcy': '${model.DayOfWeekFreqcy}','StartDate': '${model.StartDate}','EndDate': '${model.EndDate}'${recommendationSeriesId ? `, 'RcmndtnSeriesId': '${recommendationSeriesId}'` : ''}}`,
            );
          } else if (type === "low-high") {
            data.push(
                `{'Row': '${model.Row}','MeasureId': '${model.MeasureId}','UnitId': '${model.UnitId1}', 'Qty': [{ 'QtyDescrptr': 'LowQty', 'Qty': ${model.Quantity1} }, { 'QtyDescrptr': 'HighQty', 'Qty': ${model.Quantity2} }],'DayOfWeekFreqcy': '${model.DayOfWeekFreqcy}','StartDate': '${model.StartDate}','EndDate': '${model.EndDate}'${recommendationSeriesId ? `, 'RcmndtnSeriesId': '${recommendationSeriesId}'` : ''}}`,
            );
                
          } else if (type === "low-high-double") {
            data.push(
              `{'Row': '${model.Row}','MeasureId': '${model.MeasureId}','UnitId': '${model.UnitId1}', 'Qty': [{ 'QtyDescrptr': 'SystolicLowQty', 'Qty': ${model.Quantity1} }, { 'QtyDescrptr': 'SystolicHighQty', 'Qty': ${model.Quantity2} }, { 'QtyDescrptr': 'DiastolicLowQty', 'Qty': ${model.Quantity3} }, { 'QtyDescrptr': 'DiastolicHighQty', 'Qty': ${model.Quantity4} }],'DayOfWeekFreqcy': '${model.DayOfWeekFreqcy}','StartDate': '${model.StartDate}','EndDate': '${model.EndDate}'${recommendationSeriesId ? `, 'RcmndtnSeriesId': '${recommendationSeriesId}'` : ''}}`,
            );
          }

        return data;
      }
  }

  const generateApiCalls = (recommendationData, action, clientId) => {
    if (recommendationData.length === 0) return null;

    const dataText = recommendationData.join(",");
    return RecommendationAccess.confirmRecommendations(action, clientId, `[${dataText}]`, recommendationData.length);
  };

  const handleConfirmationDialogClose = (selectedItems) => {
    unOverlayTopSide();
    setAddConfirmationOpen(false);
    if (selectedItems) {
      const addedRecommendationsData = [];
      const modifiedRecommendationsData = [];
      const deletedRecommendationsData = [];
      for (let i = 0; i < selectedItems.length; i += 1) {
        const selectedItem = selectedItems[i];
        
        var model = {};
        let type = "single";
        if(selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin && selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin.length === 2){
          type = "HoursMinutes";
        } else if(selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 2 &&  selectedItem.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr === "Hours"){
          type = "HoursMinutes";

        }
        else if(selectedItem.QtyDescrptr_Qty_UnitIdArray.length > 1 && selectedItem.QtyDescrptr_Qty_UnitIdArray.every(item => item.QtyDescrptr === "Qty")){
          type = "single";
        } else if(selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 2){
          type = "low-high";
        } else if(selectedItem.QtyDescrptr_Qty_UnitIdArray.length === 4){
          type = "low-high-double";
        }

        model = createModel(selectedItem, type)

        switch (selectedItem.Action) {
          case "Added":
            model.Row = addedRecommendationsData.length + 1;
            addedRecommendationsData.push(...parseRecommendationData(model, type, "Added"));
            break;

          case "Modified":
            model.Row = modifiedRecommendationsData.length + 1;
            modifiedRecommendationsData.push(...parseRecommendationData(model, type, "Modified", selectedItem.RcmndtnSeriesId));
            break;

          case "Deleted":
            model.Row = deletedRecommendationsData.length + 1;
            deletedRecommendationsData.push(...parseRecommendationData(model, type, "Deleted", selectedItem.RcmndtnSeriesId));
            break;

          default:
              break;
        }

      }

      const { clientId } = window;

      const apiCalls = [
          generateApiCalls(addedRecommendationsData, "Added", clientId),
          generateApiCalls(modifiedRecommendationsData, "Modified", clientId),
          generateApiCalls(deletedRecommendationsData, "Deleted", clientId),
      ].filter(Boolean);

      Promise.all(apiCalls)
        .then(() => {
            toast.success(`Recommendations Confirmed!`, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
            navigate(-1);
        })
        .catch(() => {
            // Handle errors if necessary
        });
    }
  };


  const setQtyDescrptrData = (data, defaultUnit) => {
    const QtyDescrptr = data.QtyDescrptr_Qty_UnitIdArray;
    const QtyDescrptrArray = [];

    if (data.MeasureCmpntCount === '0' && data.RcmndtnType === 'Single') {
      QtyDescrptrArray.push({
        QtyDescrptr: 'Qty',
        Qty: QtyDescrptr ? QtyDescrptr.Qty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.UnitId : defaultUnit.UnitId
      });
    } else if (data.MeasureCmpntCount === '0' && data.RcmndtnType === 'Low-High') {
      QtyDescrptrArray.push({
        QtyDescrptr: 'LowQty',
        Qty: QtyDescrptr ? QtyDescrptr.LowQty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.UnitId : defaultUnit.UnitId
      });
      QtyDescrptrArray.push({
        QtyDescrptr: 'HighQty',
        Qty: QtyDescrptr ? QtyDescrptr.HighQty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.UnitId : defaultUnit.UnitId
      });
    } else if (data.MeasureCmpntCount === '2' && data.RcmndtnType === 'Low-High') {
      QtyDescrptrArray.push({
        QtyDescrptr: 'SystolicLowQty',
        Qty: QtyDescrptr ? QtyDescrptr.SystolicLowQty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.SystolicUnitId : defaultUnit.UnitId
      });
      QtyDescrptrArray.push({
        QtyDescrptr: 'SystolicHighQty',
        Qty: QtyDescrptr ? QtyDescrptr.SystolicHighQty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.SystolicUnitId : defaultUnit.UnitId
      });
      QtyDescrptrArray.push({
        QtyDescrptr: 'DiastolicLowQty',
        Qty: QtyDescrptr ? QtyDescrptr.DiastolicLowQty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.SystolicUnitId : defaultUnit.UnitId
      });
      QtyDescrptrArray.push({
        QtyDescrptr: 'DiastolicHighQty',
        Qty: QtyDescrptr ? QtyDescrptr.DiastolicHighQty : 0,
        UnitId: QtyDescrptr ? QtyDescrptr.DiastolicUnitId : defaultUnit.UnitId
      });
    }
    return QtyDescrptrArray;
  };

  const handleDynamicDialogClose = (type, data) => {
    const allModifiedRecommendations = [...modifiedRecommendations];
    const recommendations = [...RecommendationList];
    switch (type) {
      case 'EditSeries':
        const selectedRecommendation = recommendations.find(x => x.RcmndtnSeriesId === data.Id);
        selectedRecommendation.QtyDescrptr_Qty_UnitIdArray = data.QtyDescrptr_Qty_UnitIdArray;
        if(data.QtyDescrptr_Qty_UnitIdArray_HrMin && data.QtyDescrptr_Qty_UnitIdArray_HrMin.length === 2){
          selectedRecommendation.QtyDescrptr_Qty_UnitIdArray = 
           [ {QtyDescrptr: "Hours", Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin[0].Qty},
            {QtyDescrptr: "Minutes", Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin[1].Qty},
          
          ]
        }
        selectedRecommendation.DayOfWeekFreqcy = data.DayOfWeekFreqcy.toString();
        selectedRecommendation.StartDate = data.StartDate;
        selectedRecommendation.EndDate = data.EndDate;
        // selectedRecommendation.StartDateFormatted = StartDate;
        // selectedRecommendation.EndDateFormatted = EndDate;
        selectedRecommendation.Action = 'Modified';
        selectedRecommendation.IsSelected = true;
        selectedRecommendation.QtyDescrptr_Qty_UnitIdArray_OldValue = data.QtyDescrptr_Qty_UnitIdArray_OldValue;
        const selectedRecommendationModified = allModifiedRecommendations.find(x => x.RcmndtnSeriesId === data.Id);
        if (selectedRecommendationModified == null) {
          allModifiedRecommendations.push(selectedRecommendation);
        }

        setRecommendations(recommendations);
        setModifiedRecommendations(allModifiedRecommendations);

        break;

      case 'AddSeries':
        const measure = contextcache.measurements.find(x => x.MeasureId === data.MeasureId);
        if (measure) {
          data.icon = measure.MeasureIcon;
          data.iconClassName = classNameTriskeleParser(measure.VisualNameOne, measure.VisualTypeOne, 'Icon');
        }
        data.QtyDescrptr_Qty_UnitIdArray = data.QtyDescrptr_Qty_UnitIdArray;
        if (data.QtyDescrptr_Qty_UnitIdArray && data.QtyDescrptr_Qty_UnitIdArray.length) {
          for (let i = 0; i < data.QtyDescrptr_Qty_UnitIdArray.length; i++) {
            const unit = contextcache.units.find(x => x.UnitID === data.QtyDescrptr_Qty_UnitIdArray[i].UnitId);
            if (unit) {
              data.QtyDescrptr_Qty_UnitIdArray[i].Unit = unit.UnitAbrvName;
            }
          }
        } 
         if(data.QtyDescrptr_Qty_UnitIdArray_HrMin && data.QtyDescrptr_Qty_UnitIdArray_HrMin.length === 2){
          data.QtyDescrptr_Qty_UnitIdArray = 
           [ {QtyDescrptr: "Hours", Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin[0].Qty},
            {QtyDescrptr: "Minutes", Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin[1].Qty},
          
          ]
        }
        data.MeasureName = measure.MeasureName;
        data.ProviderName = 'YOU';
        data.Action = 'Added';
        data.IsSelected = true;
        data.DayOfWeekFreqcy = data.DayOfWeekFreqcy.toString();
        data.PrcsParmtrValueOne = "added"
        data.StartDateFormatted = data.StartDate;
        data.EndDateFormatted = data.EndDate;
        allModifiedRecommendations.push(data);

        setRecommendations(recList => [...recList, data]);
        setModifiedRecommendations(allModifiedRecommendations);
        break;

      default:
        break;
    }
    unOverlayTopSide();
    setDynamicDialogOpen(false);
  };

     const [dialogData, setDialogData] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);


  const handleClose = () => {
    setIsDialogOpen(false);
    setDialogData(null);

  };

  const handleConfirm = () => {
    //setSkeleton(false);

    if(dialogData.type === 'RestoreSeries') {
        const recommendations = [...RecommendationList];
        let allModifiedRecommendations = [...modifiedRecommendations];
        if (dialogData.data.RcmndtnSeriesId) { // Check if Existed Recommendation or currently Added
          allModifiedRecommendations = allModifiedRecommendations.filter(x => x !== dialogData.data);
          recommendations.find(x => x === dialogData.recommendation).PrcsParmtrValueOne = null;
        } else {
          allModifiedRecommendations = allModifiedRecommendations.filter(x => x !== dialogData.data);
        }
        setRecommendations(recommendations);
        setModifiedRecommendations(allModifiedRecommendations);
    }
    else {
            let recommendations = [...RecommendationList];
            let allModifiedRecommendations = [...modifiedRecommendations];
            if (dialogData.data.RcmndtnSeriesId) { // Check if Existed Recommendation or currently Added
              allModifiedRecommendations.push(dialogData.data);
              recommendations.find(x => x === dialogData.recommendation).PrcsParmtrValueOne = 'deleted';
            } else {
              allModifiedRecommendations = allModifiedRecommendations.filter(x => x !== dialogData.recommendation);
              recommendations = recommendations.filter(x => x !== dialogData.recommendation);
            }
            setRecommendations(recommendations);
            setModifiedRecommendations(allModifiedRecommendations);
    }
    setIsDialogOpen(false);
    setDialogData(null);
  };


  const restoreRecommendation = (selectedRecommendation) => {
    if (selectedRecommendation.PrcsParmtrValueOne === 'deleted') {
      setDialogData({
            title: 'Restore Series',
            message: 'Are you sure you want to restore Series?',
            confirmText: 'Restore',
            type: 'RestoreSeries',
            recommendation: selectedRecommendation,
            data: selectedRecommendation
          });
    setIsDialogOpen(true);

    }
  };

  const deleteRecommendation = (selectedRecommendation) => {
    if (selectedRecommendation.PrcsParmtrValueOne !== 'deleted') {
    setDialogData({
      title: 'Remove Series',
      message: 'Are you sure you want to remove Series?',
      confirmText: 'Remove',
      type: 'RemoveSeries',
      recommendation: selectedRecommendation,
      data: {
                Action: 'Deleted',
                RcmndtnSeriesId: selectedRecommendation.RcmndtnSeriesId,
                RcmndtnArray: '',
                MeasureName: selectedRecommendation.MeasureName,
                MeasureId: selectedRecommendation.MeasureId,
                icon: selectedRecommendation.icon,
                Category: selectedRecommendation.Category,
                IsSelected: true,
                DayOfWeekFreqcy: selectedRecommendation.DayOfWeekFreqcy,
                StartDate: selectedRecommendation.StartDate,
                EndDate: selectedRecommendation.EndDate,
                QtyDescrptr_Qty_UnitIdArray: selectedRecommendation.QtyDescrptr_Qty_UnitIdArray
              }
    });
    setIsDialogOpen(true);
    }
  };

  const openUserProfile = (providerId) => {
    dispatch(setUserProfile(providerId));
  };
  const searchMeasure = (value) => {
    if (value === '') {
      setFilteredMeasures(measures);
      return;
    }
    const result = [];
    measures.forEach((measure) => {
      result.push({
        name: measure.name,
        order: measure.order,
        values: measure.values.filter(x => (x.ReportName ? x.ReportName.toLowerCase().includes(value.toLowerCase()) : x.MeasureName.toLowerCase().includes(value.toLowerCase())))
      });
    });
    setFilteredMeasures(result);
  };
  return (
    <div>

      {!skeleton && <DailyRecommendationSkeleton columns="4" />}

      {skeleton
                && (
              <div>
     
                <div>
                  <div className={`card_search_list ${classNameTriskeleParser("Search Bar", "Searched Boxed", "Rectangle")}`}>
                    <Icon classNames={`large_size_40 ${SEARCH_ICON}`} />
                    <input
                      className="input_search"
                      onChange={e => searchMeasure(e.target.value)}
                      placeholder="Search Measure" />
                  </div>
                    <div className="add-recommendation-grid" style={{ height: 'auto', marginTop: '12px'}}>
                        <div className="Heading6_500_NTextBlack list-of-rec-title" style={{ marginLeft: '8px'}}>List of Of Measures</div>
                        <div className="Heading6_500_NTextBlack list-of-rec-title">List of Recommendations</div>

                    </div>
                </div>
                <div className="add-recommendation-grid" >
                  <div style={{ overflowY: 'auto' }} >
                    <MeasuresList
                      filteredMeasures={filteredMeasures}
                      setAction={openDynamicDialog}
                      container="measures-grid-container"
                      type="measure"
                      />
                  </div>

                  <div style={{ overflowY: 'auto' }}>
                    <RecommendationsList
                      addedRecommendations={RecommendationList}
                      deleteRecommendation={deleteRecommendation}
                      addOrEditRecommendation={openDynamicDialog}
                      openUserProfile={openUserProfile}
                      restoreRecommendation={restoreRecommendation}
                    />
                  </div>
                </div>
                </div>
                )
            }

      {skeleton && (
      <div className="half_width row-flex column-gap-20 bottom-fixed">
        <div style={{ width: '200px' }} onClick={goBack} aria-hidden="true">
          <Button
            variant="outlined" style={{ padding: 0}}
            className={OUTLINED_BUTTON}
                     >
            Cancel
          </Button>
        </div>
        <div style={{ width: '200px' }} className="btnContained" onClick={openConfirmationDialog} aria-hidden="true">
          <Button
            variant="contained" style={{ padding: 0}}
            className={CONTAINED_BUTTON}
            disabled={modifiedRecommendations.length === 0}
                     >
            Save
          </Button>
        </div>
      </div>
      )
            }
      <AddConfirmationDialog
        open={isAddConfirmationDialogOpen}
        onClose={handleConfirmationDialogClose}
        data={otherData}
            />

      <DynamicDialog
        open={isDynamicDialogOpen}
        onClose={handleDynamicDialogClose}
        data={otherData}
        RecommendationList={RecommendationList}
            />

             {dialogData && (
                        <Dialog
                          open={isDialogOpen}
                          onClose={handleClose}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogTitle id="alert-dialog-title">
                            {dialogData.title}
                          </DialogTitle>
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              {dialogData.message}
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button onClick={handleConfirm} autoFocus>
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>)}
    </div>
  );
};

export default AddRecommendation;
